module.exports = __webpack_public_path__ + "static/media/AngelsOfAether-Gallery-12.191a2029.jpg";